export const LOAD_PRODUCT = 'PRODUCT/LOAD_PRODUCT';
export const LOAD_PRODUCT_ERROR = 'PRODUCT/LOAD_PRODUCT_ERROR';
export const LOAD_PRODUCT_SUCCESS = 'PRODUCT/LOAD_PRODUCT_SUCCESS';
